export default function Logo(): React.ReactElement {
  return (
    <svg width="146" height="36" viewBox="0 0 146 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>AMD</title>
      <g clipPath="url(#clip0_88_1236)">
        <path
          d="M111.471 0.583496L120.955 10.0735H136.504V25.6286L146 35.1186V0.583496H111.471ZM12.1667 2.91341L0 33.0867H7.96308L10.2139 27.1129H23.725L26.207 33.0867H34.3465L20.878 2.91341H12.1667ZM37.7714 2.91341V33.0563H45.3026V14.2467L53.4421 23.7488H54.5857L62.7253 14.2832V33.0867H70.2564V2.91341H63.6925L54.0078 14.1372L44.3293 2.91341H37.7714ZM75.993 2.91341V33.0867H88.5064C100.545 33.0867 106.026 26.7236 106.026 18.0487C106.026 9.77541 100.326 2.91341 89.3155 2.91341H75.993ZM83.5181 8.44925H88.3361C95.4536 8.44925 98.2519 12.7745 98.2519 18.0001C98.2519 22.4287 95.9889 27.5631 88.4213 27.5631H83.5181V8.44925ZM16.6927 10.11L21.5046 21.863H12.2153L16.6927 10.11ZM120.943 11.9776L111.185 21.7292V35.4167H124.848L134.606 25.6407H120.943V11.9776Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_88_1236">
          <rect width="146" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
